import React from 'react';
import { ConsultationForm } from '../../components/ConsultationForm';
import { useNavigate, useParams } from 'react-router-dom';
import { ROUTES } from '../../utils/routes';
import { useDispatch, useSelector } from 'react-redux';
import { GetConsultation, TypeUpdateConsultationR, UpdateConsultation } from '../../store/consultations/actions';
import { GetBlocks } from '../../store/blocks/actions';
import { GetMainBlocks } from '../../store/main/actions';
import { AppStore } from '../../store/applicationState';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { ConfigurationsActions } from '../../store/configurations/actions';

export const EditConsultation: React.FC = () => {
  const { Consultations } = useSelector((store: AppStore) => store);
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (id) {
      dispatch(GetConsultation.request({ id: Number(id) }));
    }
  }, [dispatch, id]);

  React.useEffect(() => {
    if (Consultations.current) {
      dispatch(ConfigurationsActions.setSiteId(Consultations.current.siteId));
    }
  }, [dispatch, Consultations]);

  const handleUpdate = (data: TypeUpdateConsultationR['data'], callBack: (err?: string) => void) => {
    if (!Consultations.current) return null;

    dispatch(
      UpdateConsultation.request({
        data,
        id: Consultations.current.id,
        callBack: (success, dta) => {
          if (!success && dta) {
            if (dta.status === 409) callBack('Такий заголовок вже використовується');
            else callBack('Сталася помилка');
          } else {
            callBack();
          }
          if (success && Consultations.current?.isPublic === 1 && data.isPublic === 0) {
            dispatch(GetBlocks.request({ id: Consultations.current.siteId }));
            dispatch(GetMainBlocks.request({ id: Consultations.current.siteId }));
          }
        },
      })
    );
  };

  if (!Consultations.current)
    return (
      <Box display={'flex'} justifyContent={'center'} alignItems={'center'} height={'100vh'}>
        <CircularProgress color='secondary' />
      </Box>
    );

  return (
    <ConsultationForm
      type='edit'
      data={Consultations.current}
      handleSubmit={handleUpdate}
      handleCancel={() => navigate(ROUTES.routeChange('list'))}
    />
  );
};
